export enum PaymentFormValues {
  card = 'card',
  cardholderName = 'cardholderName',
  exp = 'exp',
  cvv = 'cvv',
}

export enum RegistrationFormValues {
  email = 'email',
}

export enum EmailVerificationFormValues {
  code = 'code',
}

export enum EmailFormValues {
  email = 'email',
}
